module.exports = __webpack_public_path__ + "static/media/nl.4a033d74.webp";